import { searchFormStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchForm";
import { css } from "styled-components";

searchFormStyles.wrapper = {
    css: css`
        // border: 10px solid #000;
        > div > div[class^="GridWrapper"] {
            > div > div[class^="GridItemStyle"] {
                > div[class^="Wrapper"] {
                    > div > div[class^="FormFieldStyle"] {
                        > div[class^="FormInputWrapper"] {
                            select {
                                padding-right: 30px;
                            }
                        }
                    }
                }
            }
        }
    `,
};
